import axios from "../configRequest";

interface RequestParams {
    country_code?: string;
    provider_code?: string;
    search: string;
    limit?: number;
    page?: number;
}
export interface ParcelMachine {
    id: number;
    ref: string;
    name_pl: string;
}
interface GetParcelMachinesResponse {
    status: number;
    data: ParcelMachine[];
    pagination: {
        total: number;
        last_page: number;
        current_page: number;
    };
}
const DEFAULT_PARAMS: Partial<RequestParams> = {
    country_code: "pl",
    provider_code: "in_post",
};
export async function apiGetParcelMachines(
    params: RequestParams,
): Promise<GetParcelMachinesResponse> {
    const fetchData = await axios.get<GetParcelMachinesResponse>(
        "https://demo-logistics.new-brz.net/api/v1/pickup-points/search",
        {
            headers: {
                Accept: "application/json;charset=UTF-8",
            },
            params: { ...DEFAULT_PARAMS, ...params },
        },
    );

    return fetchData.data;
}
